import makeReducerFor from "./_genericDbReducer";
import { createSelector } from "reselect";
import { getFlowItemsForSelectedFlow } from "./flowItems";

import type { FlowItem, FlowSegmentSplit, FlowRelation } from "../types/flowTypes";

const myGenericReducer = makeReducerFor("FLOW_SEGMENT_SPLIT", "SegmentSplitId");
import subItemReducer from "./_genericFlowSubItemReducer";
import { getFlowRelationsArray } from "./flowRelations";

const myReducer = (state = {}, action) => subItemReducer(myGenericReducer(state, action), action);
export default myReducer;

export type FlowSegmentSplitsByItemId = {
    [number]: Array<FlowSegmentSplit>,
};

export const getFlowSegmentSplitArray = createSelector(
    state => state.flowSegmentSplits.byId,
    (flowSegmentSplitsById: {| [number]: FlowSegmentSplit |}): Array<FlowSegmentSplit> => {
        const r: Array<FlowSegmentSplit> = Object.values(flowSegmentSplitsById);
        return r;
    }
);

// eslint-disable-line
export const getFlowSegmentSplitsByFlowItemId = createSelector(
    state => getFlowSegmentSplitArray(state),
    (flowSegmentSplits: Array<FlowSegmentSplit>): FlowSegmentSplitsByItemId =>
        flowSegmentSplits.reduce((acc, row) => {
            if (!acc[row.FlowItemId]) {
                acc[row.FlowItemId] = [];
            }
            acc[row.FlowItemId].push(row);
            return acc;
        }, {})
);

export const getFlowSegmentSplitsForSelectedFlow = createSelector(
    state => getFlowItemsForSelectedFlow(state),
    state => getFlowSegmentSplitsByFlowItemId(state),
    (flowItems: Array<FlowItem>, flowSegmentSplitsByItemId: FlowSegmentSplitsByItemId): Array<FlowSegmentSplit> => {
        const itemIds = flowItems.map(fi => fi.FlowItemId);
        let result = [];
        for (const itemId of itemIds) {
            const script = flowSegmentSplitsByItemId[itemId];
            if (script != null) {
                result = result.concat(script);
            }
        }
        return result;
    }
);

export const getFlowSegmentSplitsForSelectedFlowItem = createSelector(
    state => state.selected.flowItem,
    state => getFlowItemsForSelectedFlow(state),
    state => getFlowRelationsArray(state),
    state => getFlowSegmentSplitsByFlowItemId(state),
    (flowItemId: number,
     flowItems: Array<FlowItem>,
     flowRelations: Array<FlowRelation>,
     flowSegmentSplitsByItemId: FlowSegmentSplitsByItemId): Array<FlowSegmentSplit> => {
        let result = [];

        // Find the selected flow item
        const selectedFlowItem = flowItems.find(fi => fi.FlowItemId === flowItemId);

        // Check if the selected flow item is of type 'multiexport'
        if (selectedFlowItem && selectedFlowItem.FlowItemType === 'multiexport') {
            // Get all related items where the current flowItemId is the parent
            const childExportItems = flowRelations.filter(
                relation => relation.ParentFlowItemId === flowItemId
            );

            // Collect split fields for each related item
            for (const exportItem of childExportItems) {
                const splitFields = flowSegmentSplitsByItemId[exportItem.ChildFlowItemId];
                if (splitFields) {
                    result = result.concat(splitFields);
                }
            }
        } else {
            // If not 'multiexport', return the splits for the current flowItemId
            result = flowSegmentSplitsByItemId[flowItemId] || [];
        }

        return result;

    }
);
